<script setup lang="ts">
const {
  title,
  description = "",
  titleTag = "h2",
} = defineProps<{
  title: string;
  description?: string;
  titleTag?: "h1" | "h2" | "h3";
}>();
</script>

<template>
  <div class="flex items-start gap-3">
    <div
      v-if="$slots.icon"
      class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary"
    >
      <slot name="icon" />
    </div>
    <div class="min-w-0">
      <component
        :is="titleTag"
        class="text-2xl font-bold leading-8 tracking-tight text-app-text"
      >
        {{ title }}
      </component>
      <p v-if="description" class="mt-1 text-sm leading-5 text-app-muted">
        {{ description }}
      </p>
    </div>
  </div>
</template>
